import type { BillingView } from '@/lib/billingFilters';

interface BillingViewToggleProps {
  view: BillingView;
  onChange: (view: BillingView) => void;
  pendingCount: number;
  historyCount: number;
}

// Control segmentado que alterna entre la mesa de trabajo limpia
// ("Ver Solo Pendientes", activo por defecto) y el historial de lo liquidado.
export default function BillingViewToggle({
  view,
  onChange,
  pendingCount,
  historyCount,
}: BillingViewToggleProps) {
  const baseBtn = 'flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer';
  const activeBtn = 'bg-primary-600 text-white';
  const idleBtn = 'text-foreground-600 hover:text-foreground-900';

  return (
    <div className="inline-flex items-center bg-background-100 rounded-full p-1 gap-1">
      <button
        type="button"
        onClick={() => onChange('pending')}
        className={`${baseBtn} ${view === 'pending' ? activeBtn : idleBtn}`}
      >
        <i className="ri-time-line text-sm"></i>
        Ver Solo Pendientes
        <span
          className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold ${
            view === 'pending' ? 'bg-white/25 text-white' : 'bg-background-200 text-foreground-600'
          }`}
        >
          {pendingCount}
        </span>
      </button>
      <button
        type="button"
        onClick={() => onChange('history')}
        className={`${baseBtn} ${view === 'history' ? activeBtn : idleBtn}`}
      >
        <i className="ri-history-line text-sm"></i>
        Mostrar Historial / Pagadas
        <span
          className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold ${
            view === 'history' ? 'bg-white/25 text-white' : 'bg-background-200 text-foreground-600'
          }`}
        >
          {historyCount}
        </span>
      </button>
    </div>
  );
}